import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from 'shared/components/footer/Footer';
import FlyingMoneyBackground from 'shared/components/FlyingMoneyBackground';
import './copyTrading.css';
import 'shared/styles/buttons.css'

const Koala = ({navbarHeight}) => {
    const section1Ref = useRef(null);
        const section2Ref = useRef(null);
        const section3Ref = useRef(null);
        const [bgHeight, setBgHeight] = useState(0);
    
        const button1ref = useRef(null);
        const [button2Width, setButton2width] = useState(0);
    
        useEffect(() => {
            if (section1Ref.current) {
                const section1Height = section1Ref.current.offsetHeight;
                setBgHeight(section1Height + navbarHeight);
            }
        }, [navbarHeight]);
    
        useEffect(() => {
            if (button1ref.current) {
                const button1Width = button1ref.current.offsetWidth
                setButton2width(button1Width)
            }
    
        })
    
        const scrollToSection = (sectionRef) => {
            if (sectionRef.current) {
                sectionRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        };
    
        return (
            <div className="main-content">
                    <div>
                        <img src='.././assets/images/backgrounds/bg1.png'
                            className='copy-section1-bg'
                            style={{ height: `${bgHeight}px` }}
                            alt="Background" />
    
                        <div className="copy-section1" ref={section1Ref}>
                            <div className="copy-section1-header">
                                <h1><span>Copy Koala's Trades</span> & <span>Grow Your Wallet!</span> 📈🐨</h1>
                                <h2>JOIN KOALA'S EXCLUSIVE COPY TRADING PROGRAM ON BLOFIN!</h2>
                            </div>
                            <div className="copy-section1-buttons">
                                <a href="https://partner.blofin.com/d/CRYPTOXNFT" target="_blank"><button className="button-light" style={{ width: `${button2Width}px` }}>SIGN UP</button></a>
                                <button onClick={() => scrollToSection(section3Ref)} className="button-light" ref={button1ref}>RESULTS</button>
                            </div>
    
                            <div className="copy-section1-horizontal-line"></div>
    
                            <div className="copy-section1-images-main">
                                <div className="copy-section1-images-left">
                                    <div className="copy-section1-images-wrapper">
                                        <h2>KOALA'S 30D ROI: +266,94%</h2>
                                        <img src=".././assets/images/services/copy/koalaPNL.png" alt="30 day pnl" />
                                    </div>
                                </div>
    
                                <div className="copy-section1-images-right">
                                    <div className="copy-section1-images-wrapper">
                                        <h2>KOALA'S 7D ROI: +4,190.54$</h2>
                                        <img src=".././assets/images/services/copy/koalaPNL2.png" alt="current balance" />
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div className="copy-section2" ref={section2Ref}>
                            <h1>JOIN US TODAY</h1>
                            <h2>- LIMITED PLACES -</h2>
                            <div className="copy-section2-steps">
                                <div className="copy-step">
                                    <h2 className="copy-steps-header">STEP 1</h2>
                                    <h3>Create a BloFin Account</h3>
                                    <p>Only “cryptoxnft” promo code counts!</p>
                                    <a href="https://partner.blofin.com/d/CRYPTOXNFT" target="_blank"><button>CREATE ACCOUNT</button></a>
                                </div>
    
                                <div className="copy-step">
                                    <h2 className="copy-steps-header">STEP 2</h2>
                                    <h3>Download BloFin App</h3>
                                    <div className="copy-step-images">
                                        <a href="https://apps.apple.com/us/app/blofin/id1616804346" target="_blank"><img src=".././assets/images/services/copy/appstore.png" alt="Download App 1" /></a>
                                        <a href="https://play.google.com/store/apps/details?id=com.blofin.android" target="_blank"><img src=".././assets/images/services/copy/googleplay.png" alt="Download App 2" /></a>
                                    </div>
                                </div>
    
                                <div className="copy-step">
                                    <h2 className="copy-steps-header">STEP 3</h2>
                                    <h3>Deposit minimum 100$</h3>
                                </div>
    
                                <div className="copy-step">
                                    <h2 className="copy-steps-header">STEP 4</h2>
                                    <h3>Copy Koala's Trades</h3>
                                    <a href="https://blofin.com/copy-trade/details/8764862453"><button>COPY TRADES</button></a>
                                </div>
                            </div>
                            <h1>YOU MUST USE PROMO CODE: <span>CRYPTOXNFT</span></h1>
                            <h2>Join our FREE TELEGRAM GROUP for daily insights!</h2>
                            <a href="https://t.me/cryptoxnfts" target="_blank"><button>TELEGRAM</button></a>
                        </div>
    
                        <div className="copy-section3" ref={section3Ref}>
                            <h1>RESULTS</h1>
                            <div className="copy-section3-row">
                                <div className="copy-section3-left">
                                    <div className="copy-section3-left-content">
                                        <h2>30D ROI</h2>
                                        <img src=".././assets/images/services/copy/koalaPNL.png" alt="image" />
                                    </div>
                                </div>
                                <div className="copy-section3-right">
                                    <div className="copy-section3-right-content">
                                        <h2>7D PNL: $4,190.54</h2>
                                        <img src=".././assets/images/services/copy/koalaPNL2.png" alt="image" />
                                    </div>
                                </div>
                            </div>
    
                            <div className="copy-section3-row">
                                <div className="copy-section3-left">
                                    <div className="copy-section3-left-content">
                                        <h2>PNL Graph</h2>
                                        <img src=".././assets/images/services/copy/koalaPNL3.png" alt="image" />
                                    </div>
                                </div>
                                <div className="copy-section3-right">
                                    <div className="copy-section3-right-content">
                                        <h2>INDICATORS</h2>
                                        <img src=".././assets/images/services/copy/koalaPNL4.png" alt="image" />
                                    </div>
                                </div>
                            </div>
    
                            <button onClick={() => scrollToSection(section2Ref)}>SIGN UP</button>
                        </div>
                    </div>
                <div className="footer"><Footer /></div>
            </div>
        );
}

export default Koala
